var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp-grid" }, [
    _c("div", { staticClass: "pdp-grid__header" }, [
      _c("div", { staticClass: "pdp-grid__count" }, [
        _c("b", [_vm._v(_vm._s(_vm.tiles.length))]),
        _vm._v(
          " " + _vm._s(_vm.tiles.length === 1 ? "image" : "images") + "\n      "
        ),
        _vm.generatingCount > 0
          ? _c("span", { staticClass: "pdp-grid__generating" }, [
              _vm._v(" · " + _vm._s(_vm.generatingCount) + " generating"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pdp-grid__actions" }, [
        _vm.showStop
          ? _c(
              "button",
              {
                staticClass: "pdp-grid__stop",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.act("pdp_grid_stop")
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-x-lg" }), _vm._v(" Stop\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-grid__btn",
            attrs: { type: "button", disabled: !_vm.canCreate },
            on: {
              click: function ($event) {
                return _vm.act("create_pdp_mixed_layout:false")
              },
            },
          },
          [_vm._v("\n        Create Layout\n      ")]
        ),
        _vm._v(" "),
        _vm.grid.hasAiOrScene
          ? _c(
              "button",
              {
                staticClass: "pdp-grid__btn pdp-grid__btn--primary",
                attrs: { type: "button", disabled: !_vm.canCreate },
                on: {
                  click: function ($event) {
                    return _vm.act("create_pdp_mixed_layout:true")
                  },
                },
              },
              [_vm._v("\n        Create Editable Layout\n      ")]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pdp-grid__tiles" },
      [
        _vm._l(_vm.tiles, function (tile) {
          return _c(
            "div",
            {
              key: tile.rowIndex,
              staticClass: "pdp-grid__tile",
              class: `pdp-grid__tile--${tile.state}`,
              on: {
                mouseenter: function ($event) {
                  _vm.hovered = tile.rowIndex
                },
                mouseleave: function ($event) {
                  _vm.hovered = null
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "pdp-grid__badge",
                  class: {
                    "pdp-grid__badge--gallery": tile.mode === "gallery",
                    "pdp-grid__badge--plain": _vm.isUseAsIs(tile),
                  },
                },
                [_vm._v(_vm._s(_vm.badgeText(tile)))]
              ),
              _vm._v(" "),
              _vm.canToggleProductMode(tile) &&
              _vm.hovered === tile.rowIndex &&
              !_vm.grid.stopped
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-grid__mode",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "pdp-grid__mode-btn",
                          class: {
                            "is-active":
                              _vm.tileProductMode(tile) === "separate",
                          },
                          attrs: {
                            type: "button",
                            title:
                              "Layered: regenerates this image with a clean background (no product), then adds the product as a separate, editable layer when you create the layout.",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.act(
                                `pdp_grid_mode:${tile.rowIndex}:separate`
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Layered\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-grid__mode-btn",
                          class: {
                            "is-active":
                              _vm.tileProductMode(tile) === "integrated",
                          },
                          attrs: {
                            type: "button",
                            title:
                              "Static: regenerates this image with the product composited in (flat, not an editable layer).",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.act(
                                `pdp_grid_mode:${tile.rowIndex}:integrated`
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Static\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              tile.state === "done" && tile.url
                ? [
                    _c("img", {
                      staticClass: "pdp-grid__img",
                      attrs: { src: tile.url, alt: tile.label },
                      on: {
                        click: function ($event) {
                          return _vm.openTile(tile)
                        },
                      },
                    }),
                    _vm._v(" "),
                    tile.overlayUrl
                      ? _c("img", {
                          key: tile.overlayUrl,
                          staticClass: "pdp-grid__overlay",
                          attrs: { src: tile.overlayUrl, alt: "Product" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    tile._mrhiCallouts &&
                    tile._mrhiCallouts.type === "cambridge"
                      ? _c("div", { staticClass: "pdp-grid__callouts" }, [
                          _c(
                            "div",
                            { staticClass: "pdp-grid__callout-flavor" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(tile._mrhiCallouts.flavorText) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pdp-grid__callout-count" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(tile._mrhiCallouts.countText) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _c("div", { staticClass: "pdp-grid__placeholder" }, [
                    _c("i", {
                      staticClass: "bi bi-stars",
                      class: {
                        "pdp-grid__spark--active": tile.state === "generating",
                        "pdp-grid__spark--queued":
                          tile.state === "queued" || tile.state === "stopped",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__label" }, [
                      _vm._v(_vm._s(tile.label)),
                    ]),
                  ]),
              _vm._v(" "),
              tile.state === "done" &&
              _vm.hovered === tile.rowIndex &&
              !_vm.grid.stopped
                ? _c("div", { staticClass: "pdp-grid__hover" }, [
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__hover-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.act(
                              `pdp_grid_regenerate:${tile.rowIndex}`
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "bi bi-arrow-counterclockwise",
                        }),
                        _vm._v(" Regenerate\n        "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__hover-x",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.act(`pdp_grid_skip:${tile.rowIndex}`)
                          },
                        },
                      },
                      [_vm._v("\n          ✕\n        ")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              tile.state === "regenerating"
                ? _c("div", { staticClass: "pdp-grid__tile-spinner" }, [
                    _c("i", { staticClass: "bi bi-arrow-repeat spin" }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              tile.state === "skipped" || tile.state === "stopped"
                ? _c("div", { staticClass: "pdp-grid__skipped" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          tile.state === "stopped" ? "Stopped" : "Skipped"
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              tile.state === "error"
                ? _c("div", { staticClass: "pdp-grid__error" }, [
                    _vm._v("\n        Failed\n        "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__hover-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.act(`pdp_grid_retry:${tile.rowIndex}`)
                          },
                        },
                      },
                      [_vm._v("\n          Retry\n        ")]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        }),
        _vm._v(" "),
        _vm.addableTypes.length
          ? _c("div", { staticClass: "pdp-grid__tile pdp-grid__add-tile" }, [
              _c(
                "button",
                {
                  ref: "addTrigger",
                  staticClass: "pdp-grid__add-trigger",
                  class: { "is-open": _vm.addableTypesOpen },
                  attrs: { type: "button" },
                  on: { click: _vm.toggleAddDropdown },
                },
                [
                  _c("i", { staticClass: "bi bi-plus-lg" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add image type")]),
                ]
              ),
              _vm._v(" "),
              _vm.addableTypesOpen
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-grid__add-dropdown-menu",
                      class: {
                        "pdp-grid__add-dropdown-menu--down":
                          _vm.dropdownOpensDown,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pdp-grid__add-dropdown-header" },
                        [_vm._v("\n          Add more to this set\n        ")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.addableTypes, function (t) {
                        return _c(
                          "button",
                          {
                            key: t.key,
                            staticClass: "pdp-grid__add-item",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.addType(t.key)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-plus-lg" }),
                            _vm._v(" " + _vm._s(t.label) + "\n        "),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.lightboxTile
      ? _c(
          "div",
          {
            staticClass: "pdp-grid__lightbox",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeLightbox.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "pdp-grid__lightbox-download",
                attrs: { type: "button", title: "Download image" },
                on: { click: _vm.downloadLightboxImage },
              },
              [_c("i", { staticClass: "bi bi-download" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pdp-grid__lightbox-close",
                attrs: { type: "button" },
                on: { click: _vm.closeLightbox },
              },
              [_vm._v("\n      ✕\n    ")]
            ),
            _vm._v(" "),
            _vm.hasPrev
              ? _c(
                  "button",
                  {
                    staticClass:
                      "pdp-grid__lightbox-nav pdp-grid__lightbox-nav--prev",
                    attrs: { type: "button", title: "Previous image" },
                    on: { click: _vm.showPrev },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-left" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasNext
              ? _c(
                  "button",
                  {
                    staticClass:
                      "pdp-grid__lightbox-nav pdp-grid__lightbox-nav--next",
                    attrs: { type: "button", title: "Next image" },
                    on: { click: _vm.showNext },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-right" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pdp-grid__lightbox-stage" }, [
              _c("img", {
                staticClass: "pdp-grid__lightbox-img",
                attrs: {
                  src: _vm.lightboxTile.url,
                  alt: _vm.lightboxTile.label,
                },
              }),
              _vm._v(" "),
              _vm.lightboxTile.overlayUrl
                ? _c("img", {
                    staticClass: "pdp-grid__lightbox-overlay",
                    attrs: { src: _vm.lightboxTile.overlayUrl, alt: "Product" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.lightboxTile._mrhiCallouts &&
              _vm.lightboxTile._mrhiCallouts.type === "cambridge"
                ? _c("div", { staticClass: "pdp-grid__lightbox-callouts" }, [
                    _c(
                      "div",
                      { staticClass: "pdp-grid__lightbox-callout-flavor" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.lightboxTile._mrhiCallouts.flavorText) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pdp-grid__lightbox-callout-count" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.lightboxTile._mrhiCallouts.countText) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }